






































































































































































import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import VirtualTable from "@/components/table/VirtualTable.vue";
import SelectSessionBtn from "@/views/customize/data-sources/modals/source-details/SelectSessionBtn.vue";
import { computed, onMounted } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
import { table_config } from "./table.config";
import AzFileShareTableRow from "./AzFileShareTableRow.vue";
import { UseModal } from "@/components/root/modal";
import ContentLabelTreeModalVue from "../../common/info-types-modal/ContentLabelTreeModal.vue";
import ThemeImg from "@/components/ThemeImg.vue";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
export default Vue.extend({
  components: {
    PageWithMainContainer,
    SelectSessionBtn,
    VirtualTable,
    ThemeImg,
    SkeletonLoaderItem,
  },
  setup() {
    const {
      loading,
      az_file_share_row_items,
      save_selected_labels_ids,
      selected_labels_count,
      l0_labels,
      selected_session,
      sessions,
      set_selected_session,
      az_file_share_items,
      selected_az_file_share_row_item,
      set_selected_file_share_row_item,
      set_selected_l0_code,
      selected_l0_code,
      selected_labels,
    } = state;

    const display_no_results_cmp = computed(() => {
      return (
        !loading.value.is_loading &&
        !az_file_share_items.has_no_results.value &&
        !is_loading.value
      );
    });

    const open_new_session_modal = async () => {
      const { state: data_sources } = await import(
        "@/views/customize/data-sources/data/state"
      );
      const res = await data_sources.ext.open_scan_session_modal_for_source(
        "az_file_share"
      );
      if (res == "refresh") {
        state.init(true);
      }
    };

    const show_labels_modal = async () => {
      const res = await UseModal().show(ContentLabelTreeModalVue, {
        labels: selected_labels.value,
      });
      if (res.type == "success") {
        // @ts-ignore
        const selected_labels_ids = res.msg as string[];
        save_selected_labels_ids(selected_labels_ids);
      }
    };

    const {
      is_loading,
      items,
      has_no_results,
      load_more_items,
    } = az_file_share_items;

    onMounted(() => {
      state.init();
    });
    return {
      loading,
      az_file_share_row_items,
      save_selected_labels_ids,
      selected_labels_count,
      selected_session,
      sessions,
      set_selected_session,
      open_new_session_modal,
      selected_az_file_share_row_item,
      set_selected_file_share_row_item,
      table_config,
      AzFileShareTableRow,
      is_loading,
      items,
      display_no_results_cmp,
      has_no_results,
      load_more_items,
      show_labels_modal,
      set_selected_l0_code,
      selected_l0_code,
      l0_labels,
    };
  },
});
